module.exports = __webpack_public_path__ + "7dae19b4.svg";